import Component from './Deals.container';

export default Component;
